import { useListenRecord } from "@/hooks/useListenRecord";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const { authStatus } = useAuthenticator((context) => [context.route]);

  useListenRecord();

  if (authStatus === "configuring") return null;

  return authStatus === "authenticated" ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
